<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a drop down to select campaign based on school
    * returns both the school and campaign selected
    *
    * @since 20201027
    * @author Matthew Allen <mallen@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div class="row">
        <div class="form-group col-6">
            <label>Postcode Radius Search</label>
            <input class="form-control" v-model="postal" :placeholder="placeholder" />
        </div>
        <div class="col-6">
            <label>Radius</label>
            <div class="input-group">
                <select class="form-control" v-model="radius">
                    <option v-for="index in 50" :key="index" :value="index">{{index}}</option>
                </select>
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Units ({{units}})</button>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" @click="setUnits('mi')">mi</a>
                        <a class="dropdown-item" @click="setUnits('km')">km</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            id: String,
            value: {
                default: ''
            }
        },
        data() {
            return {
                radius: '',
                postal: '',
                units: 'mi',
                placeholder: 'Please Enter Postcode'
            }
        },
        mounted() {
            if (this.value) {
                const values = this.value.split('|');
                if (values.length) {
                    this.radius = values[0];
                    this.units = values[1];
                    this.postal = values[2];
                }
            }
        },
        watch: {
            radius: function() {
                const val = this.postalRadius();
                this.$emit('input', val);
            },
            postal: function() {
                const val = this.postalRadius();
                this.$emit('input', val);
            },
            units: function() {
                const val = this.postalRadius();
                this.$emit('input', val);
            }
        },
        methods: {
            setUnits: function(unit) {
                this.units = unit;
            },
            postalRadius: function() {
                const radius = this.radius ? this.radius : '';
                const postal = this.postal ? this.postal : '';
                const units = this.units ? this.units : 'mi';
                return radius + '|' + units + '|' + postal;
            }
        }
    }
</script>
